module.exports = __webpack_public_path__ + "media/form-type-page/clipboard-check-85358031.svg";